import type {FormatXMLElementFn} from '@sail/intl';
import {message} from '@sail/intl';

export const messages = {
  businessAndSupportDetailsSectionTitle: message({
    id: 'connectEmbed.accountManagement.businessAndSupportDetails.sectionTitle',
    defaultMessage: 'Business and support details',
    description: 'Section title for the business and support details section',
  }),

  businessAndSupportDetailsSectionSubtitle: message({
    id: 'connectEmbed.accountManagement.businessAndSupportDetails.sectionSubtitle',

    defaultMessage:
      'Add information to verify your business and help customers contact you. Manage how your business appears on payment statements, invoices, and receipts.',

    description:
      'Section subtitle for the business and support details section',
  }),

  personalInformationSectionTitle: message({
    id: 'connectEmbed.accountManagement.personalInformation.sectionTitle',
    defaultMessage: 'Personal information',
    description: 'Section title for the personal information section',
  }),

  personalInformationSectionSubtitle: message<{
    LearnMore: FormatXMLElementFn;
  }>({
    id: 'connectEmbed.accountManagement.personalInformation.sectionSubtitle',

    defaultMessage:
      'Add information about yourself to verify company ownership. <LearnMore>Learn more</LearnMore>',

    description: 'Section subtitle for the personal information section',
  }),

  payoutInformationSectionTitle: message({
    id: 'connectEmbed.accountManagement.payoutInformation.sectionTitle',
    defaultMessage: 'Payout information',
    description: 'Section title for the payout information section',
  }),

  payoutInformationSectionSubtitle: message<{
    LearnMore: FormatXMLElementFn;
  }>({
    id: 'connectEmbed.accountManagement.payoutInformation.sectionSubtitle',

    defaultMessage:
      'Manage your payout schedule and choose a destination for your payouts. <LearnMore>Learn more</LearnMore>',

    description: 'Section subtitle for the payout information section',
  }),

  linkedAccountsSectionTitle: message({
    id: 'connectEmbed.accountManagement.linkedAccounts.sectionTitle',
    defaultMessage: 'Linked external accounts',
    description: 'Section title for the linked external accounts section',
  }),

  linkedAccountsSectionSubtitle: message<{
    LearnMore: FormatXMLElementFn;
  }>({
    id: 'connectEmbed.accountManagement.linkedAccounts.sectionSubtitle',

    defaultMessage:
      'External financial accounts are sometimes required to enable certain features and payment methods. <LearnMore>Learn more</LearnMore>',

    description: 'Section subtitle for the linked accounts section',
  }),

  expandAll: message({
    id: 'connectEmbed.accountManagement.expandAll',
    description: 'Expand all button in the account management component',
    defaultMessage: 'Expand all',
  }),

  collapseAll: message({
    id: 'connectEmbed.accountManagement.collapseAll',
    description: 'Collapse all button in the account management component',
    defaultMessage: 'Collapse all',
  }),

  edit: message({
    id: 'connectEmbed.accountManagement.edit',
    description: 'Button text to edit an account management component',
    defaultMessage: 'Edit',
  }),

  viewAndEdit: message({
    id: 'connectEmbed.accountManagement.viewAndEdit',
    description: 'Button text to edit an account management component',
    defaultMessage: 'View and edit',
  }),

  addBankAccount: message({
    id: 'connectEmbed.accountManagement.addBankAccount',

    description:
      'Button text to add a bank account in the account management component',

    defaultMessage: 'Add account',
  }),

  linkAccountMessage: message({
    id: 'connectEmbed.accountManagement.addBankAccount.linkAccountMessage',

    description:
      'Message describing the option to link a bank account using Stripe.js',

    defaultMessage: 'Link an account using Stripe.js',
  }),

  manualBankEntryMessage: message({
    id: 'connectEmbed.accountManagement.addBankAccount.manualBankEntryMessage',
    description: 'Message describing the option to add a bank account manually',
    defaultMessage: 'Enter bank details manually instead',
  }),

  addLinkedAccount: message({
    id: 'connectEmbed.accountManagement.addLinkedAccount',

    description:
      'Button text to add a linked account in the account management component',

    defaultMessage: 'Link an account',
  }),

  failedToLoad: message({
    id: 'connectEmbed.accountManagement.failedToLoad',

    description:
      'Error message informing the user that loading their account information failed',

    defaultMessage: "Your account information couldn't be loaded",
  }),

  tryAgain: message({
    id: 'connectEmbed.accountManagement.tryAgain',
    description: 'Try again button to refetch the query',
    defaultMessage: 'Try again',
  }),

  viewAndEditInformation: message({
    id: 'connectEmbed.accountManagement.viewAndEditInformation',
    description: 'View and edit information button text',
    defaultMessage: 'View and edit information',
  }),

  loadingMessage: message({
    id: 'connectEmbed.accountManagement.loadingMessage',
    description: 'Loading message',
    defaultMessage: 'Your information is loading',
  }),
};
